import { useState, useRef } from "react";

import { API_URL } from "../helpers";

import Input from "../components/Input";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const DonationForm = ({ handleDonation }) => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});

	const formElement = useRef(null);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/registrationDonation`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handleDonation(json.amount);
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<form
			ref={formElement}
			method="post"
			action="/"
			onSubmit={(e) => handleSubmit(e)}
			className="well"
		>
			<div className="form-group">
				<Input
					name="amount"
					label="Enter Donation Amount"
					reqd={true}
					value={""}
					update={handleUpdate}
					errors={errors}
					addonIcon="fa-dollar-sign"
				/>

				<div className="empty" />
			</div>

			<div className="msg-submit">
				{msg.type && <Msg data={msg} />}

				<div
					className={
						msg.type === "working" || msg.type === "success"
							? "hidden"
							: "submit-container"
					}
				>
					<Submit submit="Select Donation Only" />
				</div>
			</div>
		</form>
	);
};

export default DonationForm;
